import { render, staticRenderFns } from "./SalaryLoan.vue?vue&type=template&id=d7152a46&"
import script from "./SalaryLoan.vue?vue&type=script&lang=js&"
export * from "./SalaryLoan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports